import { BillDueDaysConfiguration } from "./BillDueDaysConfiguration";
export class BillDueDaysConfigurations {
    _configurations = [];
    constructor(configurations = []) {
        this.configurations = configurations;
        this.updateJsValues();
    }
    updateModelValues() {
        this._configurations.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._configurations.forEach((bm) => bm.updateJsValues());
    }
    get configurations() {
        return this._configurations;
    }
    set configurations(value) {
        if (!value || value.length === 0) {
            this._configurations = [];
            return;
        }
        // check type and inflate
        this._configurations = value.map((c) => {
            if (c instanceof BillDueDaysConfiguration) {
                return c;
            }
            return new BillDueDaysConfiguration(c);
        });
    }
    get all() {
        return this._configurations;
    }
    get allCustom() {
        return this._configurations.filter((c) => c.type === "custom");
    }
    get hasCustom() {
        return this.allCustom.length > 0;
    }
    get hasActiveCustom() {
        return this._configurations.some((c) => c.type === "custom" && c.active);
    }
    /** only rows that are active */
    get allActive() {
        return this._configurations.filter((c) => c.active);
    }
    /** rows that are BOTH custom and active */
    get allCustomActive() {
        return this._configurations.filter((c) => c.type === "custom" && c.active);
    }
    /* activate / deactivate helpers */
    activateAll() {
        this._configurations.forEach((c) => (c.active = true));
    }
    deactivateAll() {
        this._configurations.forEach((c) => (c.active = false));
    }
    /** true when more than one row (active OR inactive) shares the same term # */
    isDuplicateTermNumber(termNumber) {
        return this._configurations.filter((c) => c.termNumber === termNumber).length > 1;
    }
    /** sort in-place by termNumber ascending, preserving UI / model sync */
    reSort() {
        this.updateModelValues(); // commit any JS edits
        this._configurations.sort((a, b) => a.termNumber - b.termNumber);
        this.updateJsValues(); // refresh JS mirrors
    }
    addConfiguration(configuration) {
        this._configurations.push(configuration);
    }
    removeConfigurationAtIndex(index) {
        this._configurations.splice(index, 1);
    }
    get length() {
        return this._configurations.length;
    }
    atIndex(index) {
        if (index < 0) {
            return this.first;
        }
        return this._configurations[index];
    }
    get first() {
        return this._configurations[0];
    }
    get last() {
        return this._configurations[this._configurations.length - 1];
    }
    get json() {
        return this.allCustom.map((c) => c.json);
    }
    toJSON() {
        return this.json;
    }
}
